module.exports = __webpack_public_path__ + "img/p4.6ab17e62.png";